import { BACKEND_URL } from 'services/constants';

export const apiBase = () => (BACKEND_URL ? `${BACKEND_URL}/api` : '/api');

export const apiUrl = path => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${apiBase()}${normalized}`;
};
